import React from "react"
import Intro from "@/common/components/_UI/Intro"

interface SectionHeadingProps {
  title: string
  description?: string
  type?: string
}

const SectionHeading = ({ title, description, type }: SectionHeadingProps) => {
  return (
    <Intro title2={title} desc={description} type={`center ${type}`} center />
  )
}

export default SectionHeading
